import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminOliveService } from '../services/admin-olive.service';
import { SessionService } from '../services/session.service';

/**
 * Libera a rota só para quem é Admin Oliv-e (flag do perfil de acesso) E tem a permissão
 * declarada em data[0].claim.valor.
 *
 * Difere do PermissionsGuard em dois pontos: as duas condições são exigidas juntas, e a role
 * não substitui a permissão — era justamente esse "ou" que deixava qualquer usuário
 * administrador entrar em telas internas.
 */
@Injectable({
  providedIn: 'root'
})
export class AdminOliveGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly adminOliveService: AdminOliveService,
    private readonly router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (!this.sessionService.isAuthenticated()) {
      this.sessionService.resetSession();
      // state.url é a página pedida; router.url ainda é a anterior (ou '/' num F5) durante os guards.
      const returnUrl = state?.url ?? this.router.url;
      return of(this.router.createUrlTree(['/login'], { queryParams: { returnUrl } }));
    }

    const permissaoExigida = route.data[0]?.claim?.valor;
    const permissoesUsuario = this.sessionService.getSession().userdata || [];
    const temPermissao = !permissaoExigida || permissoesUsuario.includes(permissaoExigida);

    return this.adminOliveService
      .garantirResolvido()
      .pipe(
        map((ehAdminOlive) =>
          ehAdminOlive && temPermissao ? true : this.router.createUrlTree(['/dash/acesso-negado'])
        )
      );
  }
}
